import { ColumnConfig } from '../hooks/useTablePreferences';

export const leadColumns: ColumnConfig[] = [
  {
    key: 'createdAt',
    label: 'Opened',
    defaultWidth: 150,
    minWidth: 120,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'subClinic',
    label: 'District',
    defaultWidth: 110,
    minWidth: 90,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'name',
    label: 'Name',
    defaultWidth: 180,
    minWidth: 140,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'idNumber',
    label: 'ID Number',
    defaultWidth: 130,
    minWidth: 110,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'phone',
    label: 'Phone',
    defaultWidth: 140,
    minWidth: 120,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'email',
    label: 'Email',
    defaultWidth: 200,
    minWidth: 140,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'status',
    label: 'Status',
    defaultWidth: 120,
    minWidth: 100,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'questionnaireSent',
    label: 'Questionnaire Sent',
    defaultWidth: 160,
    minWidth: 130,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'referral',
    label: 'Referral',
    defaultWidth: 150,
    minWidth: 110,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'referralFile',
    label: 'Referral Doc',
    defaultWidth: 120,
    minWidth: 100,
    visible: true,
    sortable: false,
    resizable: true,
    draggable: true,
  },
];
